export default __webpack_public_path__ + "static/media/TaxPayerLogoFrench.b073b07e.svg";